import { render, staticRenderFns } from "./HomeDialog.vue?vue&type=template&id=71c5731a&scoped=true&"
import script from "./HomeDialog.vue?vue&type=script&lang=js&"
export * from "./HomeDialog.vue?vue&type=script&lang=js&"
import style0 from "./HomeDialog.vue?vue&type=style&index=0&id=71c5731a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c5731a",
  null
  
)

export default component.exports